import React from 'react';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';

import LoadingButton from '../../../components/LoadingButton';
import removeSVG from './assets/remove.svg';
import selectableSVG from './assets/selectable.svg';
import selected from './assets/selected.svg';

const DepositRow = (props: Props) => {
	const isSelected = props.selected && !props.image && props.type === 'savedPayment';
	const isSavedPaymentType = props.type === 'savedPayment' && !!props.onRemove;
	const selectable = isSelected ? selected : selectableSVG; // defaults this to selectable if not a saved payment type.
	const imageSource = props.image ? props.image : <img src={selectable} alt={props.title} />;
	const [removeMode, setRemoveMode] = React.useState(false);

	const RemoveConfirmation = () => {
		return (
			<RemoveWrapper>
				<CancelRemove
					onClick={() => {
						setRemoveMode(false);
					}}
				>
					<CancelText>CANCEL</CancelText>
				</CancelRemove>
				<Remove onClick={() => props.onRemove && props.onRemove()}>
					<RemoveText>REMOVE</RemoveText>
				</Remove>
			</RemoveWrapper>
		);
	};

	return (
		<ImageRowContainer onClick={props.onClick} isSavedPaymentType={isSavedPaymentType} isOnTop={props.isOnTop || false}>
			<RowImage isSavedPaymentType={isSavedPaymentType}>{imageSource}</RowImage>
			{isSavedPaymentType && (
				<img src={props.icon} alt="payment icon" height={35} style={{ marginRight: 6, maxWidth: 70 }} />
			)}
			<RowTitle>{isSavedPaymentType ? <strong>{props.title}</strong> : props.title}</RowTitle>
			{isSavedPaymentType && (
				<>
					{props.buttonFunction && (
						<ViewCodesButton>
							<LoadingButton
								className="_w-auto _grow-0 _btn _btn-primary-action _rounded"
								onClick={props.buttonFunction}
							>
								VIEW CODES
							</LoadingButton>
						</ViewCodesButton>
					)}
					{removeMode ? (
						<RemoveConfirmation />
					) : (
						<RemoveButton
							onClick={(e) => {
								e.stopPropagation();
								setRemoveMode(true);
							}}
						>
							<img src={removeSVG} alt="remove" />
						</RemoveButton>
					)}
				</>
			)}
			{!isSavedPaymentType && <ChevronRight />}
		</ImageRowContainer>
	);
};

export default DepositRow;

interface Props {
	title: string;
	image?: JSX.Element;
	type: 'savedPayment' | 'paymentType';
	selected?: boolean;
	onRemove?: () => void;
	onClick: () => void;
	buttonFunction?: () => void;
	icon?: string;
	isOnTop?: boolean;
}

const ImageRowContainer = styled.div<{ isSavedPaymentType: boolean; isOnTop: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	width: calc(100% + 24px);
	height: 60px;
	margin-left: -12px;
	margin-right: -12px;
	padding: 12px;
	${(props) => {
		return props.isSavedPaymentType
			? `border-bottom: 1px solid #ccc;`
			: `
			border-top: 1px solid #ccc;`;
	}}
	${(props) => {
		return props.isOnTop && `border-top: none;`;
	}}

	> button {
		margin-left: auto;
	}
`;

const RowImage = styled.div<{ isSavedPaymentType: boolean }>`
	> img {
		height: 30px;
	}
	width: 130px;
	${(props) => {
		return (
			props.isSavedPaymentType &&
			`
			width: 14px;
			margin-right: 12px;
		`
		);
	}}
	display: flex;
`;

const RowTitle = styled.div`
	font-size: 14px;
	color: #4a5568;
`;

const RemoveButton = styled.button`
	width: 14px;
	height: 14px;
	margin-left: auto;
`;

const ViewCodesButton = styled.div`
	margin-left: 35px;
	> button {
		flex-grow: 0;
	}
`;

const RemoveWrapper = styled.div`
	width: 154px;
	height: 60px;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-right: -16px;
	margin-left: auto;
`;

const CancelRemove = styled.div`
	background-color: #f2f2f2;
	width: 50%;
	height: 100%;
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: black;
`;

const Remove = styled(CancelRemove)`
	background-color: #c53030;
`;

const CancelText = styled.span`
	text-align: center;
	font-size: 13px;
	font-weight: bold;
`;

const RemoveText = styled(CancelText)`
	color: #fff;
`;

const ChevronRight = styled(FaChevronRight)`
	margin-left: auto;
	color: #191d22;
`;
